import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

export class Heading extends React.Component {
  render() {
    return (
      <div className='heading'>
          <h2>{this.props.text}</h2>
      </div>
    )
  }
}
Heading.propTypes = {
  type: PropTypes.string,
  content: PropTypes.array,
  text: PropTypes.string.isRequired,
};
